import {front} from 'app/api/CirrusApi';
import {TeamContract} from 'app/components/entities/team/models';
import {apiClient} from 'app/components/shared';

export class TeamApi {
  static async getMembers(teamId: string): Promise<TeamContract.Member[]> {
    return apiClient.get<TeamContract.Member[]>(
      `/front/api/v1t/team/${teamId}/teams/${teamId}/users`,
    );
  }

  static async removeMember(teamId: string, userId: string): Promise<void> {
    return front.teams(teamId).users(userId).delete();
  }

  static async setMemberRole(
    teamId: string,
    userId: string,
    role: 'admin' | 'operator',
  ): Promise<void> {
    return front
      .teams(teamId)
      .users(userId)
      .put({Role: role === 'admin' ? 'owner' : role});
  }

  static async transferOwnership(
    teamId: string,
    userId: string,
    savePayment: boolean,
  ): Promise<void> {
    return front.teams(teamId).users(userId).master().put({KeepCard: savePayment});
  }

  static rename(teamId: string, name: string): Promise<void> {
    return apiClient.put<void, {Name: string}>(`/front/api/v1t/team/${teamId}/teams/${teamId}`, {
      Name: name,
    });
  }

  static async getTeams(): Promise<TeamContract.Team[]> {
    return apiClient.get<TeamContract.Team[]>('/front/api/v1/teams');
  }

  static async getTeamDetails(teamId: string): Promise<TeamContract.TeamDetails> {
    return apiClient.get<TeamContract.TeamDetails>(`/front/api/v1/teams/${teamId}`);
  }

  static async validate(ids: string[]): Promise<{team_id: string}> {
    return apiClient.post<{team_id: string}>(`/front/api/v1/teams/validate`, {team_ids: ids});
  }
}
